import { Injectable } from '@angular/core';
import { ApiService } from '@core/auth/auth.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  _form = new BehaviorSubject<any>(null);

  constructor(
    private _ApiService: ApiService,
  ) { }

  getDynamicForm(formdata: any) {
    return this._ApiService.post(config.ticketing.raise.universal_form, formdata).pipe(switchMap((res: any) => {
      this._form.next(res)
      return of(res);
    }))
  }
}
